
import { readable, writable } from 'svelte/store'
import { persisted } from 'svelte-local-storage-store'


export const isLoading = writable(false);
export const loadingMessage = writable('Loading, please wait...');
export const user = writable({loggedin: false, email: "", uid: "", employerUid: ""});
export const userAccount = writable({email: "", password: ""});
export const code_verifier = persisted('verifier', '');
const isBrowser = typeof window !== 'undefined'; // Ensure we're in the browser

// Load cart from localStorage only in the browser
const storedCart = isBrowser ? JSON.parse(localStorage.getItem('cart')) || [] : [];

export const cart = writable(storedCart);
export const stripeKey ="sk_test_51Q9DjbFzNB581xYvHCz1FT0KFb3SamZUnFlfMW08C0aD5bY29apNlOCeNrsf4ztkRa3tMP2lJTxRr7bDDXiVj4GM00A3SPXdxr";
export const discount20 = "eONrsHFU";
export const prices = writable({
    employerpriceannual: "",
    employerpricemonth: "",
    employeepriceannual: "",
    employeepricemonth: "",
});
export const product_codes = readable({
    employerprod: "prod_Rn9u9yvD4mWZbS",
    employerpriceannual: "price_1QtZb0FzNB581xYvWebSFapc",
    employerpricemonth: "price_1QtZb0FzNB581xYvsbVfBQtH",
    employeeprod: "prod_Rn9ttNAdLEgeAf",
    employeepriceannual: "price_1QtZaRFzNB581xYvyouMqv97",
    employeepricemonth: "price_1QtZaBFzNB581xYvpjd0CwGm",
});

// Save to localStorage only in the browser
if (isBrowser) {
    cart.subscribe(value => {
        localStorage.setItem('cart', JSON.stringify(value));
    });
}
export function updateQuantity(productName, newQuantity) {
    cart.update(items => {
        return items.map(item =>
            item.name === productName ? { ...item, quantity: newQuantity } : item
        );
    }
)};

export const popupMessage = writable('');
export const showPopup = writable(false);

export function showError(message) {
    popupMessage.set(message);
    showPopup.set(true);
}

export function hidePopup() {
    showPopup.set(false);
    popupMessage.set('');
}